var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("table", { staticStyle: { width: "100%" } }, [
        _c("tr", [
          _c("td", [
            _c("div", { staticStyle: { "float：left；width": "200px" } }, [
              _c("h1", [_vm._v(_vm._s(_vm.translateWords.AreaManage))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [
            _vm._v("\n        " + _vm._s(_vm.translateWords.RegionName) + "： ")
          ]),
          _c(
            "td",
            { staticStyle: { float: "left" } },
            [
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { placeholder: _vm.translateWords.RegionName },
                model: {
                  value: _vm.RegionQuery.RegionName,
                  callback: function($$v) {
                    _vm.$set(_vm.RegionQuery, "RegionName", $$v)
                  },
                  expression: "RegionQuery.RegionName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("td", [
            _vm._v("\n        " + _vm._s(_vm.translateWords.Status) + "：")
          ]),
          _c(
            "td",
            { staticStyle: { float: "left" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.translateWords.Status },
                  model: {
                    value: _vm.RegionQuery.Status,
                    callback: function($$v) {
                      _vm.$set(_vm.RegionQuery, "Status", $$v)
                    },
                    expression: "RegionQuery.Status"
                  }
                },
                _vm._l(_vm.RegionStatusDropList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("td", [
            _vm._v("\n        " + _vm._s(_vm.translateWords.Country) + "：")
          ]),
          _c(
            "td",
            { staticStyle: { float: "left" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.translateWords.Country },
                  model: {
                    value: _vm.RegionQuery.DepartMentID,
                    callback: function($$v) {
                      _vm.$set(_vm.RegionQuery, "DepartMentID", $$v)
                    },
                    expression: "RegionQuery.DepartMentID"
                  }
                },
                _vm._l(_vm.RegionCountryDropList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm.PermissonList.Search.value
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.query } },
                    [_vm._v(_vm._s(_vm.translateWords.query))]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm.PermissonList.Add.value
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.add } },
                    [_vm._v(_vm._s(_vm.translateWords.add))]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        { staticStyle: { width: "90%" }, attrs: { data: _vm.tableData } },
        [
          _c("el-table-column", {
            attrs: { prop: "Id", label: _vm.translateWords.Code, width: "100" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "RegionName", label: _vm.translateWords.RegionName }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "Status", label: _vm.translateWords.Status }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "CountryName", label: _vm.translateWords.Country }
          }),
          _vm._v(" "),
          false
            ? _c("el-table-column", {
                attrs: { prop: "IsUseKey", label: _vm.translateWords.IsUseKey }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "IsUseKeyStr", label: _vm.translateWords.IsUseKey }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "KeyCount", label: _vm.translateWords.KeyCount }
          }),
          _vm._v(" "),
          false
            ? _c("el-table-column", {
                attrs: {
                  prop: "DepartMentID",
                  label: _vm.translateWords.Country
                }
              })
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c("el-table-column", {
                attrs: { prop: "StatusCode", label: _vm.translateWords.Status }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.translateWords.operate },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.PermissonList.Update.value
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.$index, scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.translateWords.edit))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.PermissonList.Delete.value
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.handleDelete(scope.$index, scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.translateWords.delete))]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": 1,
          "page-sizes": [10, 20, 30],
          "page-size": 10,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "30%",
            "show-close": true,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("table", [
            _c("tr", [
              _c("td", [
                _c("div", { staticStyle: { float: "left" } }, [
                  _c("h1", [_vm._v(_vm._s(_vm.translateWords.title))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "200x"
                      }
                    },
                    [
                      _c("table", [
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.translateWords.RegionName,
                                    prop: "RegionName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.ruleForm.RegionName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "RegionName",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.RegionName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.translateWords.Status,
                                    prop: "Status"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder:
                                          _vm.translateWords.statusText,
                                        filterable: ""
                                      },
                                      model: {
                                        value: _vm.ruleForm.Status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.ruleForm, "Status", $$v)
                                        },
                                        expression: "ruleForm.Status"
                                      }
                                    },
                                    _vm._l(
                                      _vm.AddRegionStatusDropList,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.translateWords.Country,
                                    prop: "DepartMentID"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder:
                                          _vm.translateWords.conuntryText,
                                        filterable: ""
                                      },
                                      model: {
                                        value: _vm.ruleForm.DepartMentID,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "DepartMentID",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.DepartMentID"
                                      }
                                    },
                                    _vm._l(
                                      _vm.AddRegionCountryDropList,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.translateWords.IsUseKey,
                                    prop: "IsUseKey"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder: _vm.translateWords.IsUseKey
                                      },
                                      on: { change: _vm.changeisusekey },
                                      model: {
                                        value: _vm.ruleForm.IsUseKey,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "IsUseKey",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.IsUseKey"
                                      }
                                    },
                                    _vm._l(_vm.IsUseKeyDropList, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.showkeycount
                          ? _c("tr", [
                              _c(
                                "td",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.translateWords.KeyCount,
                                        prop: "KeyCount",
                                        rules: [
                                          {
                                            required: true,
                                            message: "钥匙数量不能为空"
                                          },
                                          {
                                            type: "number",
                                            message: "钥匙数量必须为数字值"
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.ruleForm.KeyCount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "KeyCount",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "ruleForm.KeyCount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticStyle: { float: "left" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.submitForm("ruleForm")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.translateWords.Save))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29216fe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29216fe8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegionNew.vue
// module id = null
// module chunks = 